import React, { useState, useMemo } from "react";
import { Button, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../../redux/actions/CartActions";
import "./Hero.css";

function Hero() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.authUser);
  const { userCompanies } = useSelector((state) => state.companies);

  const [loading, setLoading] = useState(null); // "creation" | "domiciliation" | "management" | "formalities" | null

  const isLoggedIn = isAuthenticated && !!user;
  const hasCompanies = Array.isArray(userCompanies) && userCompanies.length > 0;

  const cta = useMemo(
    () => [
      {
        key: "creation",
        label: "Créer mon entreprise",
        onClick: async () => {
          await dispatch(addToCart({ from: "creation" }));
          if (isLoggedIn) navigate("/business-country");
          else navigate("/account-check");
        },
      },
      {
        key: "domiciliation",
        label: "Domicilier mon entreprise",
        onClick: async () => {
          await dispatch(addToCart({ from: "domiciliation" }));
          if (isLoggedIn)
            navigate(hasCompanies ? "/companies" : "/business-country");
          else navigate("/account-check");
        },
      },
      {
        key: "management",
        label: "Gérer mon entreprise",
        onClick: async () => {
          await dispatch(addToCart({ from: "management" }));
          if (isLoggedIn)
            navigate(hasCompanies ? "/companies" : "/business-country");
          else navigate("/account-check");
        },
      },
      {
        key: "formalities",
        label: "Formalités diverses",
        variant: "outline",
        onClick: async () => navigate("/formalities"),
      },
    ],
    [dispatch, isLoggedIn, hasCompanies, navigate]
  );

  const handleClick = async (action) => {
    try {
      setLoading(action.key);
      await action.onClick();
    } finally {
      setLoading(null);
    }
  };

  return (
    <section id="hero" className="hero-2025" aria-labelledby="hero-title">
      <Container className="text-center hero-inner">
        <p className="eyebrow mb-2">Platform98</p>

        <h1 id="hero-title" className="display-5 fw-semibold hero-title">
          Créez, domiciliez, pilotez & développez votre{" "}
          <span className="accent">business</span>
          <br className="d-none d-md-block" /> où que vous soyez.
        </h1>

        <p className="hero-subtitle text-muted mx-auto">
          Nous gérons vos démarches administratives et juridiques, partout où
          nous sommes présents.
        </p>

        <div className="cta-wrap">
          {cta.map((action) => (
            <Button
              key={action.key}
              variant={
                action?.variant === "outline" ? "outline-light" : "light"
              }
              className={`cta-btn ${
                action?.variant === "outline" ? "cta-outline" : ""
              }`}
              aria-label={action.label}
              onClick={() => handleClick(action)}
              disabled={loading !== null}
            >
              {loading === action.key ? (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              {action.label}
            </Button>
          ))}
        </div>

        {/* <div className="trust mt-4">
          <div className="trust-item">⏱️ Démarrage en quelques minutes</div>
          <div className="dot" />
          <div className="trust-item">🔒 Données sécurisées</div>
          <div className="dot" />
          <div className="trust-item">💬 Support humain</div>
        </div> */}
      </Container>

      <div className="hero-glow" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />
    </section>
  );
}

export default Hero;
